import {
    get,
    post
} from "../axios/http"

export const getVersions1 = () => {
    return new Promise((resolve, reject) => {
        resolve({
            data: {
                Code: 'geobyte',
                Version: '0.0.16',
                Link: 'https://cgsapp.s3.cn-north-1.amazonaws.com.cn/GeoByte.Android-v0.0.15.apk',
                Desc: ''
            }
        })
    })
};
export const  getVersions = (Co) =>get(`/api/apk/version?Code=${Co}`)